import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 6,
    label: i18n.t('ENVIRONMENTS_PAGE.TIME_DISCONNECT_KEY'),
    stateKey: 'disconnection_time',
    isSelect: true,
    options: [
      { label: `5 ${i18n.t('MINUTES_KEY')}`, value: 5 },
      { label: `10 ${i18n.t('MINUTES_KEY')}`, value: 10 },
      { label: `20 ${i18n.t('MINUTES_KEY')}`, value: 20 },
      { label: `30 ${i18n.t('MINUTES_KEY')}`, value: 30 },
      { label: `40 ${i18n.t('MINUTES_KEY')}`, value: 40 },
      { label: `50 ${i18n.t('MINUTES_KEY')}`, value: 50 },
      { label: `1 ${i18n.t('TIME_KEY')}`, value: 60 },
    ],
  },
  {
    gridXs: 12,
    label: i18n.t('ENVIRONMENTS_PAGE.EMAIL_NOTIFICATION_IMAGE_KEY'),
    stateKey: 'notification_email',
    type: 'email',
  },
  {
    gridXs: 6,
    label: i18n.t('ENVIRONMENTS_PAGE.YOUR_NAME_KEY'),
    stateKey: 'operator_name',
  },
  {
    gridXs: 12,
    label: i18n.t('ENVIRONMENTS_PAGE.USER_MSG_IMAGE_KEY'),
    stateKey: 'user_message',
  },
];

export default fields;
